import * as React from 'react';
import { Responsive } from '@cian/ui-kit/responsive';

import { Text } from '../Text';
import { DesktopView } from './views/DesktopView';
import { MobileView } from './views/MobileView';
import { content } from './content';

import * as styles from './styles.css';
import { Container } from '../Container';

export const AnalyticsUsefulFor: React.FC = () => {
  return (
    <div className={styles['wrapper']}>
      <Container>
        <div className={styles['title']}>
          <Text size={'h2'} bold>
            Кому будет полезна аналитика?
          </Text>
        </div>
        <Responsive desktop>
          <DesktopView content={content} />
        </Responsive>
        <Responsive tablet phone>
          <MobileView content={content} />
        </Responsive>
      </Container>
    </div>
  );
};

AnalyticsUsefulFor.displayName = 'AnalyticsUsefulFor';
